export function Placeholder({ title, note }: { title: string; note: string }) {
  return (
    <div className="grid flex-1 place-items-center">
      <div className="text-center">
        <h1 className="text-[var(--title)] font-extrabold tracking-tight">{title}</h1>
        <p className="mt-2 text-sm text-mute">{note}</p>
      </div>
    </div>
  );
}
